import classNames from 'classnames';
import { Optional } from '../Common/interfaces';
import { LabelBodySmall } from '../features/modules/components';
import { getColorsForStatus, ValidationStatus } from './FormContext';

type Props = {
    validationStatus: Optional<ValidationStatus>;
    children: React.ReactNode;
    className?: string;
};
export function FormValidationMessage({
    validationStatus,
    children,
    className,
}: Props) {
    const colors = getColorsForStatus(validationStatus);
    return (
        <LabelBodySmall className={classNames(className, colors?.textColor)}>
            {children}
        </LabelBodySmall>
    );
}
